import s, { useState as r, useEffect as E, useMemo as O } from "react";
import { useWindowEvent as F } from "../../../../../features/dom/hooks/useWindowEvent.js";
import { getCacheAddressInfoKey as I } from "./shared.js";
const f = s.createContext({});
function J() {
  return s.useContext(f);
}
function N({
  children: m
}) {
  const [p, l] = r([]), [c, g] = r(!1), [i, a] = r({}), { dispatchEvent: v } = F(), [o, d] = r({
    name: "address"
  }), [t, u] = r({
    place: null,
    addressInfo: localStorage.getItem(I()) ?? void 0
  });
  E(() => {
    typeof window !== void 0 && (window.ordering = JSON.parse(JSON.stringify(t)), v("formChange", {
      ordering: t
    }));
  }, [t]);
  const S = (e) => {
    a({}), l((n) => [...n, o]), d(e);
  }, C = () => {
    const e = p.pop();
    e !== void 0 && d(e);
  }, w = (e, n) => {
    u((y) => ({
      ...y ?? {},
      [e]: n
    }));
  }, x = O(
    () => ({
      active: c,
      setIsActive: g,
      form: t,
      currentStep: o,
      setForm: u,
      back: C,
      setFormValue: w,
      setStep: S,
      errors: i,
      setErrors: a
    }),
    [t, o, c, i]
  );
  return /* @__PURE__ */ s.createElement(f.Provider, { value: x }, m);
}
export {
  f as OrderingFormContext,
  N as OrderingFormProvider,
  J as useOrdering
};
//# sourceMappingURL=context.js.map
